import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-lista-editable',
  templateUrl: './lista-editable.component.html',
  styleUrls: ['./lista-editable.component.scss'],
})
export class ListaEditableComponent implements OnInit {
  @Input() set Datos(val){
    this.Valores = val.split(",")
  } 
 @Input() Valores = []
 @Output() Value = new EventEmitter();
  constructor(private conexion: ConexionService, private utilidades: UtilidadesService) { }

  ngOnInit() {}

  agregar(ev){
    if(ev.key=="Enter"){
      let val = ev.target.value;
      if(val){
        this.Valores.push(val)
        ev.target.value = ""
        this.Value.emit(this.Valores.toString())
      }
    }
  }

  editar(ev, indice){
    if(ev.key=="Enter"){
      this.Valores[indice] = ev.target.value
        this.Value.emit(this.Valores.toString())
      }
    }
  
  quitar(ev, i){
      let val = ev.target.value;
      if(val==""){
        this.Valores.splice(i,1)
        this.Value.emit(this.Valores.toString())
      }else{
        this.Valores[i] = val
      }
  }



}
